import BlocklistResource from 'flow/api/blocklist';
import {
    networkErrorDispatcher,
    httpGetErrorDispatcher,
} from 'flow/actions/app-actions';
import Actions from 'flow/actions';

export const getBlockLists = () => (dispatch) =>
    new Promise((resolve) => {
        const onFailure = (request) => {
            httpGetErrorDispatcher(dispatch)(request);
            resolve(false);
        };

        BlocklistResource.listBlocklists({
            onResult: (json) => {
                dispatch(resultCallRoutings(json));
                resolve(true);
            },
            onError: onFailure,
            onClientError: onFailure,
        });
    });

export const createCallRouting = (blockListDTO) => (dispatch) => {
    const callRoutingList = [blockListDTO.toJS()];

    BlocklistResource.createBlocklists(
        {
            onResult: (json) => {
                dispatch(resultCallRoutings(json));
            },
            onError: networkErrorDispatcher(dispatch),
            onClientError: networkErrorDispatcher(dispatch),
        },
        callRoutingList,
    );
};

export const updateCallRouting = (blockListDTO) => (dispatch) => {
    const callRoutingList = [blockListDTO.toJS()];

    BlocklistResource.updateBlocklists(
        {
            onResult: (json) => {
                dispatch(resultUpdatedCallRoutings(json));
            },
            onError: networkErrorDispatcher(dispatch),
            onClientError: networkErrorDispatcher(dispatch),
        },
        callRoutingList,
    );
};

export const deleteCallRouting = (blockListKey) => (dispatch) => {
    const callRoutingKeyList = [blockListKey];

    BlocklistResource.deleteBlocklists(
        {
            onResult: (json) => {
                dispatch(resultDeletedCallRoutings(json));
            },
            onError: networkErrorDispatcher(dispatch),
            onClientError: networkErrorDispatcher(dispatch),
        },
        callRoutingKeyList,
    );
};

export const prioritiseNumbers = (numbers) => (dispatch) =>
    new Promise((resolve) => {
        if (numbers.length === 0) {
            resolve(true);
            return;
        }

        const priorityEntries = numbers.map((matcher) => ({
            editByUser: true,
            isIncoming: true,
            redirect: 'passthrough',
            matcher,
        }));
        const onFailure = () => {
            networkErrorDispatcher(dispatch)();
            resolve(false);
        };

        BlocklistResource.createBlocklists(
            {
                onResult: (json) => {
                    dispatch(resultCallRoutings(json));
                    resolve(true);
                },
                onError: onFailure,
                onClientError: onFailure,
            },
            priorityEntries,
        );
    });

export const removeOwnPriorityEntries = (entries) => (dispatch) =>
    new Promise((resolve) => {
        const keys = entries
            .filter((entry) => entry.get('editByUser'))
            .map((entry) => entry.get('key'))
            .toArray();

        if (keys.length === 0) {
            resolve(true);
            return;
        }

        const onFailure = () => {
            networkErrorDispatcher(dispatch)();
            resolve(false);
        };

        BlocklistResource.deleteBlocklists(
            {
                onResult: (json) => {
                    dispatch(resultDeletedCallRoutings(json));
                    const deletedKeys = json ?? [];
                    if (keys.every((key) => deletedKeys.includes(key))) {
                        resolve(true);
                    } else {
                        onFailure();
                    }
                },
                onError: onFailure,
                onClientError: onFailure,
            },
            keys,
        );
    });

export const getPredefs = () => (dispatch) => {
    BlocklistResource.listMatchingPredefs({
        onResult: (json) => {
            dispatch(resultListPredefs(json));
        },
        onError: networkErrorDispatcher(dispatch),
    });
};

const resultCallRoutings = (callRoutingsData) => ({
    type: Actions.RESULT_CALL_ROUTINGS,
    data: callRoutingsData,
});

const resultUpdatedCallRoutings = (callRoutingsData) => ({
    type: Actions.RESULT_CALL_ROUTINGS_UPDATED,
    data: callRoutingsData,
});

const resultDeletedCallRoutings = (callRoutingsData) => ({
    type: Actions.RESULT_CALL_ROUTINGS_DELETED,
    data: callRoutingsData,
});

const resultListPredefs = (predefList) => ({
    type: Actions.RESULT_CALL_ROUTINGS_PREDEFS,
    data: predefList,
});
